module.exports = __webpack_public_path__ + "static/media/star_arrow.bbfe3786.svg";